import cx from "classnames";
import React from "react";
import { scroller } from "react-scroll";

type MenuItemProps = {
  icon: React.ReactElement;
  id: string;
  onClick: (event: React.MouseEvent) => void;
  text: string;
};

const MenuItem: React.FC<MenuItemProps> = ({
  icon,
  id,
  onClick,
  text,
}: MenuItemProps): React.ReactElement => {
  const onClickItem = React.useCallback(
    (event: React.MouseEvent): void => {
      onClick(event);
      if (event.currentTarget.id) {
        const { currentTarget } = event;
        const element =
          currentTarget.id.charAt(0).toUpperCase() + currentTarget.id.slice(1);
        scroller.scrollTo(element, {
          delay: 0,
          duration: 1500,
          smooth: true,
        });
      }
    },
    [onClick],
  );

  return (
    <div
      className={cx([
        "julia-website-menu-item",
        "u-align-items-center",
        "u-cursor-pointer",
        "u-flex",
        "u-flex-column",
        "u-padding-bottom-2xs",
        "u-padding-left-xs",
        "u-padding-right-xs",
      ])}
      id={id}
      onClick={onClickItem}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClickItem(e as unknown as React.MouseEvent);
        }
      }}
      role="button"
      tabIndex={0}
    >
      {icon}
      <span
        className={cx(["u-color-white", "u-font-size-2xs", "u-line-height-xs"])}
      >
        {text}
      </span>
    </div>
  );
};

export default React.memo(MenuItem);
